/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteEquipmentSettingCommand } from '../../models/delete-equipment-setting-command';
import { DeleteEquipmentSettingCommandResult } from '../../models/delete-equipment-setting-command-result';

export interface ApiEquipmentSettingDeleteEquipmentSettingDelete$Params {
  
    /**
     * The command containing the ID of the equipment setting to delete.
     */
    body?: DeleteEquipmentSettingCommand
}

export function apiEquipmentSettingDeleteEquipmentSettingDelete(http: HttpClient, rootUrl: string, params?: ApiEquipmentSettingDeleteEquipmentSettingDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteEquipmentSettingCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiEquipmentSettingDeleteEquipmentSettingDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteEquipmentSettingCommandResult>;
    })
  );
}

apiEquipmentSettingDeleteEquipmentSettingDelete.PATH = '/api/EquipmentSetting/DeleteEquipmentSetting';
